import {
  Carousel,
  CarouselContent,
  CarouselItem,
  type CarouselApi
} from "@/components/ui/carousel"
import { Separator } from '@/components/ui/separator'
import { useGetRandomBlogs } from '@/lib/hooks/blogs/get/useGetRandomBlogs'
import Image from 'next/image'
import Link from 'next/link'
import React from 'react'
const RandomBlog = () => {
  const { data, isLoading } = useGetRandomBlogs('about-paint')
  const randomBlogs = data as Blog[]
  const [api, setApi] = React.useState<CarouselApi>()
  const [current, setCurrent] = React.useState(0)
  const [count, setCount] = React.useState(0)
  React.useEffect(() => {
    if (!api) {
      return
    }
    setCount(api.scrollSnapList().length)
    setCurrent(api.selectedScrollSnap() + 1)
    api.on("select", () => {
      setCurrent(api.selectedScrollSnap() + 1)
    })
  }, [api])
  if (isLoading) return <p>Loading...</p>;
  return (
    <div className="flex flex-col gap-4">
      <h2 className='text-xl font-bold'>Recommended Blogs</h2>
      <div className="mx-auto max-w-sm ">
        <Carousel setApi={setApi} className="w-full max-w-sm">
          <CarouselContent>
            {randomBlogs.map((blog, index) => (
              <CarouselItem key={index}>
                <Link href={false ? `/blog-dashboard/blogs/${blog.slug}` : `/blog-details/${blog.slug}`}>
                  <aside className='border p-[0.8rem] rounded-lg flex flex-col gap-4'>
                    <Image
                      src={
                        blog.image || '/assets/images/services/Construction.jpg'
                      }
                      alt={blog.image_alt || "No image url"}
                      height={400}
                      width={400}
                      className='object-cover h-[12rem] rounded-lg'
                    />
                    <Separator />
                    <h2>{blog.title}</h2>
                  </aside>
                </Link>
              </CarouselItem>
            ))}
          </CarouselContent>
        </Carousel>
      </div>
    </div>
  )
}

export default RandomBlog